import clavo from 'db/oil/_clavo'
import toronja from 'db/oil/_toronja'
import limon from 'db/oil/_limon'
import mandarina from 'db/oil/_mandarina'
import bergamota from 'db/oil/_bergamota'
import sandalo from 'db/oil/_sandalo'
import argan from 'db/oil/_argan'
import lavanda from 'db/oil/_lavanda'
import ylang from 'db/oil/_ylang-ylang'
import hiebabuena from 'db/oil/_hierbabuena'
import aguacate from 'db/oil/_aguacate'
import olivo from 'db/oil/_olivo'
import almendrasDulces from 'db/oil/_almendras-dulces'
import avellana from 'db/oil/_avellana'
import germenTrigo from 'db/oil/_germen-trigo'
import romero from 'db/oil/_romero'
import citronela from 'db/oil/_citronela'
import naranja from 'db/oil/_naranja'

const oilList = [
  clavo,
  toronja,
  limon,
  mandarina,
  bergamota,
  sandalo,
  argan,
  lavanda,
  ylang,
  hiebabuena,
  aguacate,
  olivo,
  almendrasDulces,
  avellana,
  germenTrigo,
  romero,
  citronela,
  naranja
]

export default oilList
